export const formatCurrency = (centsValue: number, roundToCents = false): string => {
  const decimalPlaces = roundToCents ? 2 : 0;
  const parsedNum = centsValue.toString().replace(/\$|,/g, '');
  const rounded = parseFloat(parsedNum).toFixed(decimalPlaces);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces,
  }).format(isNaN(Number(rounded)) ? 0 : Number(rounded));
};

export const centsToCurrencyString = (valueCents: number, roundToCents = false) => {
  return formatCurrency(valueCents / 100, roundToCents);
};

const addSuffix = (dollars: number, suffix: string): string =>
  `${dollars.toLocaleString('en-US', {
    maximumFractionDigits: suffix === 'k' ? 0 : 1,
  })}${suffix}`;

// converts currency cents from 24000000 to 240K, 240000000 to 2.4M and
// aspirationally will also handle billions correctly
export function centsToPrettyCurrencyString(valueCents: number, showDollarSign = true) {
  const valueInDollars = Math.round(valueCents / 100);
  const absoluteValue = Math.abs(valueInDollars);
  const showNegative = valueCents < 0 ? '-' : '';
  const isBillions = absoluteValue >= 1000000000;
  const isMillions = absoluteValue >= 1000000;
  const isThousands = absoluteValue >= 1000;
  const suffix = isBillions ? 'B' : isMillions ? 'M' : isThousands ? 'K' : '';

  let formattedString = `${absoluteValue}`;
  if (isBillions) {
    formattedString = addSuffix(absoluteValue / 1000000000, suffix);
  } else if (isMillions) {
    formattedString = addSuffix(absoluteValue / 1000000, suffix);
  } else if (isThousands) {
    formattedString = addSuffix(Math.round(absoluteValue / 1000), suffix);
  }

  return `${showNegative}${showDollarSign ? '$' : ''}${formattedString}`;
}

/*
TODO: Migrate to use Intl.NumberFormat once typescript is updated
https://v8.dev/features/intl-numberformat#sign
*/
export const fractionToPercentString = (
  valueFraction: number,
  maximumFractionDigits = 1,
  minimumFractionDigits = 0,
) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits,
    minimumFractionDigits,
    style: 'percent',
  }).format(valueFraction);

// converts state abbreviation to their full name
export const abbreviationToStateString: { [stateAbbreviation: string]: string } = {
  AL: 'alabama',
  AK: 'alaska',
  AZ: 'arizona',
  AR: 'arkansas',
  CA: 'california',
  CO: 'colorado',
  CT: 'connecticut',
  DE: 'delaware',
  FL: 'florida',
  GA: 'georgia',
  HI: 'hawaii',
  ID: 'idaho',
  IL: 'illinois',
  IN: 'indiana',
  IA: 'iowa',
  KS: 'kansas',
  KY: 'kentucky',
  LA: 'louisiana',
  ME: 'maine',
  MD: 'maryland',
  MA: 'massachusetts',
  MI: 'michigan',
  MN: 'minnesota',
  MS: 'mississippi',
  MO: 'missouri',
  MT: 'montana',
  NE: 'nebraska',
  NV: 'nevada',
  NH: 'new_hampshire',
  NJ: 'new_jersey',
  NM: 'new_mexico',
  NY: 'new_york',
  NC: 'north_carolina',
  ND: 'north_dakota',
  OH: 'ohio',
  OK: 'oklahoma',
  OR: 'oregon',
  PA: 'pennsylvania',
  RI: 'rhode_island',
  SC: 'south_carolina',
  SD: 'south_dakota',
  TN: 'tennessee',
  TX: 'texas',
  UT: 'utah',
  VT: 'vermont',
  VA: 'virginia',
  WA: 'washington',
  WV: 'west_virginia',
  WI: 'wisconsin',
  WY: 'wyoming',
};
